/*
 * @description: 
 * @Author: Jay
 * @Date: 2023-12-19 16:30:46
 * @LastEditors: Jay
 * @LastEditTime: 2023-12-28 14:22:41
 */
const getters = {
  //身份 0则是商户 1是代理
  user_rankType: state => state.user.rankType,
  //动态路由 列表
  permission_routes: state => state.permission.addRoutes,
  // permission_routes: state => state.permission.routes,
}
export default getters
